/*
Copyright (c) Daybrush
name: vue-selecto
license: MIT
author: Daybrush
repository: https://github.com/daybrush/selecto/blob/master/packages/vue-selecto
version: 1.10.3
*/
import VanillaSelecto, { PROPERTIES, CLASS_NAME, OPTIONS, EVENTS, METHODS } from 'selecto';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { withMethods, Properties } from 'framework-utils';
import { isUndefined } from '@daybrush/utils';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */
var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };

  return extendStatics(d, b);
};

function __extends(d, b) {
  extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

var watches = {};
PROPERTIES.forEach(function (name) {
  watches[name] = function (val) {
    this.updateProperty(name, val);
  };
});

var VueSelecto =
/*#__PURE__*/
function (_super) {
  __extends(VueSelecto, _super);

  function VueSelecto() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  var __proto = VueSelecto.prototype;

  __proto.render = function (h) {
    return h("div", {
      class: CLASS_NAME,
      ref: "target"
    });
  };

  __proto.mounted = function () {
    var _this = this;

    var props = this.$props;
    var options = {};
    OPTIONS.forEach(function (name) {
      var value = props[name];

      if (!isUndefined(value)) {
        options[name] = value;
      }
    });
    this.selecto = new VanillaSelecto(__assign(__assign({}, options), {
      target: this.$refs.target
    }));
    var selecto = this.selecto;
    EVENTS.forEach(function (name, i) {
      selecto.on(name, function (e) {
        _this.$emit(name, __assign({}, e));
      });
    });
  };

  __proto.updateProperty = function (name, value) {
    var selecto = this.selecto;
    selecto[name] = value;
  };

  __proto.beforeDestroy = function () {
    this.selecto.destroy();
  };

  __decorate([withMethods(METHODS)], VueSelecto.prototype, "selecto", void 0);

  VueSelecto = __decorate([Component({
    name: "selecto",
    watch: watches
  }), Properties(OPTIONS, function (prototype, name) {
    Prop()(prototype, name);
  })], VueSelecto);
  return VueSelecto;
}(Vue);

export { VueSelecto };
//# sourceMappingURL=selecto.esm.js.map
